import type { Theme } from '@mui/material';

import { muiSelectStyles } from 'src/theme/sharedStyles';

export const styles = {
  accordion: {
    pt: '1rem',
    px: 0,
  },

  accordionSummary: (theme: Theme) => ({
    display: 'flex',
    height: '1rem',
    alignItems: 'center',
    backgroundColor: theme.colors.neutral[50],
    border: '0.125rem solid',

    borderRadius: '0.5rem 0.5rem 0 0',
    borderColor: theme.colors.neutral[200],
    p: 0,

    '&.Mui-expanded': {
      borderBottomLeftRadius: '0.25rem solid',
      borderBottomRightRadius: '0.25rem solid',
      minHeight: '2.5rem',
    },
  }),

  accordionExpansionIcon: (theme: Theme) => ({
    fill: theme.colors.primary[600],
  }),

  divider: (theme: Theme) => ({
    pt: '1rem',
    pb: '1rem',
    borderColor: theme.colors.neutral[100],
  }),

  accordionDetails: (theme: Theme) => ({
    borderBottom: '0.125rem solid',
    borderLeft: '0.125rem solid',
    borderRight: '0.125rem solid',
    borderColor: theme.colors.neutral[200],
    borderRadius: '0 0 0.5rem 0.5rem',
    pb: 0,
    pl: 0,
  }),

  dropdown: (theme: Theme) => ({
    ...muiSelectStyles.filterSelect(theme),
    width: '100%',
  }),
  permissionsContainer: (theme: Theme) => ({
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    margin: '1.25rem -0.625rem',
    pl: '1rem',

    [theme.breakpoints.up('md')]: {
      justifyContent: 'flex-start',
    },
  }),

  permissionsBox: (theme: Theme) => ({
    m: '0.625rem 0.625rem 0 0.625rem',
    width: 'calc(50% - 1.25rem)', // Creates two cards per row

    [theme.breakpoints.down('md')]: {
      width: 'calc(100% - 1.25rem)', // One card per row on smaller screens
    },

    [theme.breakpoints.up('lg')]: {
      width: 'calc(33.33% - 1.25rem)', // Three cards per row on larger screens
    },
  }),

  fieldError: (theme: Theme) => ({
    color: theme.colors.error[500],
    flex: 1,
  }),

  placeholder: (theme: Theme) => ({
    color: theme.colors.neutral[500],
  }),

  inputs: {
    display: 'flex',
    rowGap: '1rem',
    columnGap: '1.25rem',
    width: '100%',
    p: '1rem',
    flexWrap: 'wrap',
  },
};
